var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"non-printable",attrs:{"id":"default-footer","color":"transparent","absolute":"","app":"","inset":""}},[_c('links')],1)}
var staticRenderFns = []

export { render, staticRenderFns }